import { useCallback } from 'react';
import { useUAEPass } from '../../../../../auth/hooks/uaePass/useUAEPass';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { UAEPassControlAction } from './schema/controlUAEPass';

function useControlUAEPass() {
  const { login } = useUAEPass();

  const onControlUAEPass: OnActionType = useCallback(
    async (args) => {
      const { action } = args;
      const operation = action.payload?.operation;

      switch (operation) {
        case UAEPassControlAction.Login: {
          await login();
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
        }
        default:
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      }
    },
    [login],
  );

  return { onControlUAEPass };
}

export default useControlUAEPass;
